import React from 'react';
// components
import UserAvatar from '../components/user_avatar';
// seed
import {properties} from '../seed/data';

class UserConvo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            t: '',
            messages: [
                {type: 'sender', msg: 'I am interested in your listing' },
                {type: 'receiver', msg: 'Thank you for your interest! When are you available to see the listing?'}
            ]
        }
        this.myConvo = React.createRef();
    }
    onChangeText (e) {
        this.setState({t: e.target.value})
    }
    onKeydown (e) {
        if (e.keyCode == 13 && this.state.t !== '') {
            e.preventDefault();
            let obj = {
                type: 'receiver',
                msg: this.state.t
            }
            let m = this.state.messages
            m.push(obj)
            this.setState({
                messages: m,
                t: ''
            }, () => this.scrollToBottom())
        }
    }
    scrollToBottom () {
        this.myConvo.current.scrollTop = this.myConvo.current.scrollHeight - this.myConvo.current.clientHeight+100;
    }
    renderConvo () {
        return this.state.messages.map((m, i) => <li className={`convo-item-${m.type}`}>
        <div className="convo-item">{m.msg}</div>
    </li>)
    }
    render () {
        let n = this.props.match.params.id;
        let p = n <= properties.length ? properties[n] : properties[0];
        return (
            <div className="container frame">
                <div className="row">
                <div className="col-sm-6 col-md-5 col-lg-4 col-xl-3">
                    <div className="card">
                        <div className="card-body">
                            <UserAvatar size="sm" />
                            <hr/>
                            <div className="profile-infobox-item flex-space-between">
                                <div className="profile-infobox-label">
                                    School
                                </div>
                                <div className="profile-infobox-detail">
                                    Seneca
                                </div>
                            </div>
                            <div className="profile-infobox-item flex-space-between">
                                <div className="profile-infobox-label">
                                    Program
                                </div>
                                <div className="profile-infobox-detail">
                                    PRA
                                </div>
                            </div>
                            <div className="profile-infobox-item flex-space-between">
                                <div className="profile-infobox-label">
                                    Language
                                </div>
                                <div className="profile-infobox-detail">
                                    English, Spanish
                                </div>
                            </div>
                            <div className="profile-infobox-item">
                                <div className="profile-infobox-label">
                                    Description
                                </div>
                                <div className="profile-infobox-detail profile-infobox-description-detail">
                                    Clean and fun. I just do magic 24-7. Abracadabra!
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                    <div className="col-md-9 convo-container">
                        <h4>{p.address}</h4>
                        <ul className="convo" ref={this.myConvo}>
                            {this.renderConvo()}
                        </ul>
                        <div className="convo-input">
                            <textarea type="text" placeholder="Write your message"
                                
                                value={this.state.t}
                                onChange={this.onChangeText.bind(this)}
                                onKeyDown={this.onKeydown.bind(this)}/>
                            <i className="fas fa-paper-plane"></i>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default UserConvo;